import { isNotDefined } from '@sgme/fp';
import clsx from 'clsx';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  useForwardAccumulatorSelector,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import {
  getForwardAccumulatorMarketData,
  selectForwardAccumulatorCurrencyData,
} from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

export const Vega = () => {
  const { formatNumber } = useIntl();
  const tileId = useForwardAccumulatorTileId();
  const { notionalCurrencyIndex, currency } = useAppSelector((state) =>
    selectForwardAccumulatorCurrencyData(state, tileId),
  );
  const marketData = useForwardAccumulatorSelector((accumulator) => getForwardAccumulatorMarketData(accumulator));
  const isExpired = useForwardAccumulatorSelector((accumulator) => accumulator.properties.rfs.status === 'EXPIRED');

  if (isNotDefined(notionalCurrencyIndex)) {
    return null;
  }

  const vega = marketData?.vega[notionalCurrencyIndex - 1];

  return (
    <div className={clsx('form-group form-group-sm d-flex my-1 no-gutters', { expired: isExpired })}>
      <div className="pe-1 col-form-label col-form-label-sm col-4 text-nowrap text-end" style={{ width: '30%' }}>
        <FormattedMessage id="accumulator.fields.greeks.vega" />
      </div>
      {vega && (
        <span className="col-7 fs-6" data-e2e="vega">
          {formatNumber(vega, { maximumFractionDigits: 0, minimumFractionDigits: 0 })} {currency}
        </span>
      )}
    </div>
  );
};

export default Vega;
